export default __webpack_public_path__ + "static/media/DaymondJohnProfile.3125b9ca.png";